import { render, staticRenderFns } from "./DexHeaderUserItem.vue?vue&type=template&id=23b9eca5&"
import script from "./DexHeaderUserItem.vue?vue&type=script&lang=js&"
export * from "./DexHeaderUserItem.vue?vue&type=script&lang=js&"
import style0 from "./DexHeaderUserItem.vue?vue&type=style&index=0&id=23b9eca5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports